module.exports = __webpack_public_path__ + "static/media/fly0188.16460e07.webp";